const VistaprintTenant = 'vistaprint'
const NationalPenTenant = 'national-pen'

const VistaprintMerchant = 'vistaprint'
const NationalPenMerchant = 'National Pen'

const VistaprintProdTenant = 'VISTAPRINT-PROD'
const NationalPenProdTenant = 'national-pen-dev'

export interface TenantData {
  tenant: string
  merchantId: string
  cartTenant: string
}

export function getTenantData(tenant: string): TenantData {
  switch (tenant) {
    case NationalPenTenant:
      return {
        tenant: NationalPenTenant,
        merchantId: NationalPenMerchant,
        cartTenant: NationalPenProdTenant,
      }
    case VistaprintTenant:
    default:
      return {
        tenant: VistaprintTenant,
        merchantId: VistaprintMerchant,
        cartTenant: VistaprintProdTenant,
      }
  }
}

export function getMerchantId(tenant: string): string {
  return getTenantData(tenant).merchantId
}

export function getCartTenant(tenant: string): string {
  return getTenantData(tenant).cartTenant
}
